import { useEffect, useRef } from 'react'
import Box from '@mui/material/Box'
import { loadScript } from '../../../utils/scriptLoader.js'
import './Registration.css'

const initializeRaceRegistration = (raceId) => {
  return new Promise((resolve, reject) => {
    const container = document.getElementById('divRRPublish')
    if (!container) {
      reject(new Error('Container not found'))
      return
    }

    if (container.dataset.initialized) {
      resolve()
      return
    }

    loadScript('/libs/mrr-publish.js', 'mrr-pub')
      .then(() => {
        // Manually trigger initialization that would normally happen on window.load
        if (typeof window.RRPublish === 'function') {
          new window.RRPublish(container, raceId, 'participants')
            .then(rrp => {
              rrp.ShowInfoText = false
              container.dataset.initialized = 'true'
              resolve(rrp)
            })
            .catch(reject)
        } else {
          // If RRPublish isn't available, check for initialization function
          if (typeof window.initMRR === 'function') {
            window.initMRR()
            new window.RRPublish(container, raceId)
              .then(rrp => {
                rrp.ShowInfoText = false
                container.dataset.initialized = 'true'
                resolve(rrp)
              })
              .catch(reject)
          } else {
            reject(new Error('RRPublish initialization failed'))
          }
        }
      })
      .catch(reject)
  })
}

export default function Participants ({ eventDetails }) {
  const lastInitializedRaceId = useRef(null)
  const { myRaceResultsId } = eventDetails || {}

  useEffect(() => {
    if (myRaceResultsId && myRaceResultsId !== lastInitializedRaceId.current) {
      lastInitializedRaceId.current = myRaceResultsId
      const container = document.getElementById('divRRPublish')
      if (container) container.dataset.initialized = ''
      initializeRaceRegistration(myRaceResultsId)
        .catch(error => console.error('Registration init failed:', error))
    }
  }, [myRaceResultsId])

  return <Box id='divRRPublish' className='RRPublish' />
}
